export default { PACKAGE_VERSION: "1.18.0" };
